"use strict"
var moment = require("moment");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = moment;
